import { Flex } from "antd";
import { FC, ReactNode } from "react";

import { PrimaryText } from "@/components/Typography/Styled";

interface InfoRowListProps {
    items: {
        label: string;
        value: ReactNode;
    }[];
}

export const InfoRowList: FC<InfoRowListProps> = ({ items }) => {
    return (
        <Flex vertical gap={8}>
            {items.map(({ label, value }, index) => (
                <Flex key={index} align="center" gap={8}>
                    <PrimaryText>{label}</PrimaryText>

                    <PrimaryText $textColor="accent">{value}</PrimaryText>
                </Flex>
            ))}
        </Flex>
    );
};
